<template>
  <v-container fluid>
    <!--    <l-data-table-->
    <!--      title-text="测试列表"-->
    <!--      :headers="headers"-->
    <!--      :items="items"-->
    <!--      clickable-->
    <!--    >-->
    <!--      <template slot="row-action">-->
    <!--        <td @click.stop class="px-0 mx-0 text-xs-center">-->
    <!--          &lt;!&ndash;<l-option-menu :options="options">&ndash;&gt;-->
    <!--            <v-btn slot="activator" icon class="mx-1">-->
    <!--              <v-icon small>$vuetify.icons.delete</v-icon>-->
    <!--            </v-btn>-->
    <!--          &lt;!&ndash;</l-option-menu>&ndash;&gt;-->

    <!--          <v-tooltip bottom>-->
    <!--            <v-btn slot="activator" icon class="mx-1">-->
    <!--              <v-icon small>mdi-arrow-right</v-icon>-->
    <!--            </v-btn>-->
    <!--            <span>查看子规则</span>-->
    <!--          </v-tooltip>-->

    <!--          &lt;!&ndash;<v-btn icon class="mx-1">&ndash;&gt;-->
    <!--            &lt;!&ndash;<v-icon small>mdi-information</v-icon>&ndash;&gt;-->
    <!--          &lt;!&ndash;</v-btn>&ndash;&gt;-->
    <!--        </td>-->
    <!--      </template>-->
    <!--    </l-data-table>-->
    <!--    <v-layout justify-center row>-->
    <!--      <v-flex lg10 md12>-->
    <!--        <l-plate-picker></l-plate-picker>-->
    <!--      </v-flex>-->
    <!--    </v-layout>-->
    <v-layout>
      <v-flex xs6>
        <!--        <l-cascader-->
        <!--          :items="tree"-->
        <!--          label="test label"-->
        <!--          max-width="400px"-->
        <!--          v-model="testValue"-->
        <!--        ></l-cascader>-->
        <v-text-field ref="input"></v-text-field>
        <l-plate-picker v-model="plate"></l-plate-picker>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {time} from '../../ladmin/utils'
import LVehicleViewer from '../../components/LVehicleViewer'
import {PassRule, Vehicle} from '../../object'
import SetPassRuleContent from '../../components/SetPassRuleContent'
import LPassRuleList from '../../components/LPassRuleList'
import LPlatePicker from '../../components/LPlatePicker'
import LCascader from '../../ladmin/components/LCascader/LCascader'
import SelectViolationRule from '../../components/selectViolationRule'

export default {
  name: 'TestComponents',
  components: {SelectViolationRule, LCascader, LPlatePicker, LPassRuleList, SetPassRuleContent, LVehicleViewer},
  data: () => ({
    plate: '',
    testValue: {
      text: 'level3-2',
      value: '132dfb234234'
    },
    tree: [
      {
        text: 'level1-1',
        value: '23234234234'
      },
      {
        text: 'level1-2',
        value: '23234234233',
        children: [
          {
            text: 'level2-1',
            value: '2323a234234'
          },
          {
            text: 'level2-2',
            value: '1323b23444234',
            children: [
              {text: 'level3-1', value: '2323a2sdf4234'},
              {
                text: 'level3-2',
                value: '132dfb234234',
                children: [
                  {text: 'level4-1', value: '2223a2sdf4234444'},
                  {text: 'level4-2', value: '13332dfb234234'}
                ]
              }
            ]
          }
        ]
      },
      {
        text: 'level1-3',
        value: '23234234232',
        children: [
          {text: 'level2-3', value: '2323a234234'},
          {text: 'level2-4', value: '1323b234234'}
        ]
      },
      {text: 'level1-4', value: '23234234231'}
    ],
    headers: [
      {text: '分组名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '分组描述', value: 'description', align: 'right', placeholder: 'N/A', maxWidth: '14em', tooltip: true},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '120px', sortable: false}
    ],
    options: [
      {
        icon: 'mdi-delete',
        event: 'details',
        label: '删除规则'
      },
      {
        icon: 'mdi-delete',
        event: 'details',
        label: '删除规则'
      },
      {
        icon: 'mdi-delete',
        event: 'details',
        label: '删除规则'
      }
    ],
    items: [
      {
        name: 'test',
        description: 'test',
        lastEditor: 'admin',
        creationTime: 1503348271233
      }
    ],
    dialog: {
      activate: false,
      item: {},
      status: 'new'
    },
    rules: [
      new PassRule()
    ],
    vehicle: new Vehicle({
      plate: '川ALZ000',
      owner: {
        name: 'LZ',
        phone: '18618164058',
        email: 'laizhi727@126.com',
        groupList: []
      }
    }),
    vheaders: [
      {text: '车辆号牌', value: 'carNumber', align: 'left'},
      {text: '车主姓名', value: 'name', align: 'right'},
      {text: '违章区域', value: 'area', align: 'right'},
      {text: '违章状态', value: 'status', align: 'right'}
    ]
  }),
  mounted () {
    setTimeout(() => {
      this.$refs.input.focus()
    }, 1000)
  },
  methods: {
    save (e) {
      console.log('save rule', e)
      this.dialog.activate = false
    },
    test () {
      let s = ''
      console.log(time.stringify(s))
    },
    async post () {
      this.$axios.post('/passApi/pass/log/list', {}, {})
    },
    async getData ({pagination, sortStack, filterItems, titleSwitch, search}) {
      let url = '/api/peccancy/getAll'
      try {
        let res = await this.$store.dispatch('getDataList', {pagination, url})
        return res
      }
      catch (e) {
        // this.$store.dispatch('alert', {type: 'error', title: '获取列表时发生错误', message: e.message})
        throw e
      }
    }
  }
}
</script>

<style scoped>

</style>
